// src/pages/admin/AdminLayout.jsx
import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Box, Paper, Stack, Typography, Button, Chip } from "@mui/material";
import DashboardIcon    from "@mui/icons-material/Dashboard";
import MenuBookIcon     from "@mui/icons-material/MenuBook";
import QuizIcon         from "@mui/icons-material/Quiz";
import GroupIcon        from "@mui/icons-material/Group";
import UploadFileIcon   from "@mui/icons-material/UploadFile";
import BarChartIcon     from "@mui/icons-material/BarChart";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HistoryIcon      from "@mui/icons-material/History";
import BackupIcon       from "@mui/icons-material/Backup";
import { C, indigoGradient } from "../../theme";

const NAV = [
  { to:"/admin",            label:"Dashboard",     icon:<DashboardIcon fontSize="small" />,  exact:true },
  { to:"/admin/exams",      label:"Examens",        icon:<MenuBookIcon fontSize="small" /> },
  { to:"/admin/questions",  label:"Questions",      icon:<QuizIcon fontSize="small" /> },
  { to:"/admin/users",      label:"Utilisateurs",   icon:<GroupIcon fontSize="small" /> },
  { to:"/admin/results",    label:"Résultats",      icon:<BarChartIcon fontSize="small" /> },
  { to:"/admin/analytics",  label:"Analytics",      icon:<BarChartIcon fontSize="small" /> },
  { to:"/admin/import",     label:"Import",         icon:<UploadFileIcon fontSize="small" />, badge:"CSV" },
  { to:"/admin/audit-logs", label:"Audit RGPD",     icon:<HistoryIcon fontSize="small" /> },
  { to:"/admin/backups",    label:"Backups",         icon:<BackupIcon fontSize="small" /> },
];

export default function AdminLayout() {
  const { pathname } = useLocation();
  const active = (item) => item.exact ? pathname === item.to : pathname.startsWith(item.to);

  return (
    <Box sx={{ display:"flex", gap:3, alignItems:"flex-start" }}>
      {/* Sidebar */}
      <Paper sx={{ width:210, flexShrink:0, p:1.5, position:"sticky", top:76, borderRadius:"14px" }}>
        {/* Brand badge */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ px:1.5, py:1.5, mb:1, borderRadius:2, background: `${C.indigo[50]}`, border:`1px solid ${C.indigo[100]}` }}>
          <AdminPanelSettingsIcon sx={{ color:C.indigo[600], fontSize:18 }} />
          <Typography variant="caption" fontWeight={700} sx={{ color:C.indigo[700], letterSpacing:"0.06em", textTransform:"uppercase" }}>Administration</Typography>
        </Stack>

        <Stack spacing={0.25}>
          {NAV.map(item => {
            const on = active(item);
            return (
              <Button key={item.to} component={Link} to={item.to} startIcon={item.icon}
                sx={{
                  justifyContent:"flex-start", width:"100%", px:1.5, py:1,
                  borderRadius:2, fontWeight: on ? 700 : 500, fontSize:"0.84rem",
                  color:       on ? C.indigo[700] : "text.secondary",
                  background:  on ? C.indigo[50] : "transparent",
                  "& .MuiButton-startIcon": { color: on ? C.indigo[600] : C.slate[400], mr:.75 },
                  "&:hover": { background: C.slate[50], color: C.indigo[700] },
                }}>
                <Box sx={{ flexGrow:1, textAlign:"left" }}>{item.label}</Box>
                {item.badge && <Chip label={item.badge} size="small" sx={{ height:18, fontSize:"0.6rem", fontWeight:700, background:C.teal[50], color:C.teal[700] }} />}
              </Button>
            );
          })}
        </Stack>
      </Paper>

      {/* Main content */}
      <Box sx={{ flexGrow:1, minWidth:0 }}>
        <Outlet />
      </Box>
    </Box>
  );
}